import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom"; // Import NavLink for routing
import "./Navbar.scss";
import SubmitDesign from "../../SmallComponents/SubmitDesign";

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const [isProductsDropdownOpen, setIsProductsDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<"design" | "catalog" | "needs">(
    "design"
  );
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleCategoryClick = (category: string) => {
    navigate(`/products?category=${category}`);
    setIsProductsDropdownOpen(false); // Close the dropdown
  };

  const openModal = (type: "design" | "catalog" | "needs") => {
    setModalType(type);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const toggleMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar__logo">YAMUNA FASHION</div>

        {/* Hamburger for Mobile */}
        <div className="navbar__hamburger" onClick={toggleMenu}>
          <div className="hamburger-icon"></div>
          <div className="hamburger-icon"></div>
          <div className="hamburger-icon"></div>
        </div>

        {/* Main Menu */}
        <ul className={`navbar__menu ${isMobileMenuOpen ? "active" : ""}`}>
          <li>
            <NavLink to="/" className={({ isActive }) => (isActive ? "active" : "")}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              About
            </NavLink>
          </li>
          <li
            className="navbar__menu-item--dropdown"
            onMouseEnter={() => setIsProductsDropdownOpen(true)}
            onMouseLeave={() => setIsProductsDropdownOpen(false)}
          >
            <NavLink
              to="/products"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              Products
            </NavLink>
            {/* Dropdown Menu */}
            {isProductsDropdownOpen && (
              <div className="navbar__dropdown">
                <div className="dropdown__column">
                  <h4>Men's</h4>
                  <ul>
                    <li onClick={() => handleCategoryClick("Mens-Shirts")}>Shirts</li>
                    <li onClick={() => handleCategoryClick("Mens-Tshirts")}>
                      T-Shirts
                    </li>
                    <li onClick={() => handleCategoryClick("Mens-Pants")}>Pants</li>
                  </ul>
                </div>
                <div className="dropdown__column">
                  <h4>Women</h4>
                  <ul>
                    <li onClick={() => handleCategoryClick("Seamless-Bra")}>
                      Seamless Bra
                    </li>
                    <li onClick={() => handleCategoryClick("Shorts")}>Shorts</li>
                    <li onClick={() => handleCategoryClick("Womens-Sports")}>
                      Sports
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </li>
          <li>
            <NavLink
              to="/contact"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              Contact
            </NavLink>
          </li>
        </ul>

        {/* Bulk Buy Button */}
        <button
          onClick={() => openModal("catalog")}
          className="navbar__bulk-buy"
        >
          Request Catalog
        </button>
      </nav>

      {/* Modal for Bulk Buy */}
      {isModalOpen && <SubmitDesign closeModal={closeModal} formType={modalType} />}
    </>
  );
};

export default Navbar;
